import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-55" data-mp="3k06x1v86utys">
      {eyebrow && <p className={`mb-3 text-[13px] font-bold uppercase tracking-[0.14em] ${dark ? "text-goldSoft" : "text-gold"}`} data-id="element-56" data-mp="3k29j646802y8">{eyebrow}</p>}
      <h2 className={`font-serif text-[30px] font-bold leading-[1.15] sm:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-57" data-mp="gjzsznlv2uph">{title}</h2>
      {intro && <div className={`mt-4 text-[17px] leading-relaxed sm:text-lg ${dark ? "text-white/80" : "text-muted"}`} data-id="element-58" data-mp="1u0vzo61lpbl">{intro}</div>}
    </div>;
}